var render, staticRenderFns
import script from "./timelineItem.vue?vue&type=script&lang=js&"
export * from "./timelineItem.vue?vue&type=script&lang=js&"
import style0 from "./timelineItem.vue?vue&type=style&index=0&id=be835458&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be835458",
  null
  
)

export default component.exports